(function(require2) {
  "use strict";
  require2(["login"], function(login) {
    login.bootstrap(document);
  });
})(require);
